module.exports = ".save-config-button {\n  width: 100%; }\n\npre {\n  margin: 0;\n  margin-bottom: 1.5vmin;\n  padding: 0;\n  background-color: transparent;\n  border: none; }\n\ncode {\n  border-radius: 0.25vmin;\n  width: 100%;\n  background-color: #242427;\n  -webkit-transition: background-color 0.5s ease-in-out;\n  transition: background-color 0.5s ease-in-out; }\n\n.invalid {\n  background-color: #46272a; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/jsonEditor/jsonEditor.component.scss
// module id = ./src/app/components/common/jsonEditor/jsonEditor.component.scss
// module chunks = main